export const USER_PROFILE_URL = '/user/profilejson';
export const USER_DELETE_PROFILE_URL = '/user/deletemyprofilejson';
export const USER_LOGOUT_URL = '/user/logout';
export const USER_PROFILE_FORM_NAME = 'ProfileForm';
export const USER_IMAGE_UPLOAD_URL = '/user/uploadprofileimagejson';
export const USER_IMAGE_DELETE_URL = '/user/removeprofileimagejson';

export const enum UserProfileFormValueNames {
	Email = 'email',
	FirstName = 'firstName',
	FormattedName = 'formattedName',
	GenderId = 'genderId',
	LastName = 'lastName',
	LegalName = 'legalName',
	MiddleName = 'middleName',
	Phone = 'phone',
	CountryIcon = 'countryIcon',
	CountryId = 'countryId',
	Number = 'number',
	Salutation = 'salutation',
	Skype = 'skype',
	Password = 'password',
	RecaptchaResponse = 'recaptchaResponse',
}
